import { Injectable } from '@tanbo/vue-di-plugin'
import zhfeCollect from '@zhfe/zhfe-collect'

const pubilc_filed = {
  product_no: 1,
  public_index: 6,
  business_index: 7802,

  uuid: '',
  tid1: 0,
  tid2: 0,
  tod1: 0,
  tod2: 0,
  type: 0,
  tryno: 0,
  iid: 0,
  collect_time: 0,
  lastver: 0,
  svrid: '',
  wtod2: '',
  usertype_public: 0
}

const common = {
  ver: '1'
}

@Injectable()
export class ReportService {
  constructor() {}

  webReportUrl = 'https://helpduba1.ksmobile.com/g/v1/'
  /**
   * 网页上报
   */
  webReport (data, dat = '') {
    data = Object.assign({}, common, data)
    zhfeCollect(this.webReportUrl, pubilc_filed, dat).report(data)
  }
}
